export default {
    login: { method: 'post', url: 'auth/login' },
    logout: { method: 'post', url: 'auth/logout' },
    loadSession: { method: 'get', url: 'auth/load-session' },
    create: { method: 'post', url: 'user/create' }
    // resetPassword: { method: 'post', url: 'reset-password' }

    // { mmethids: 'get', url: '/texte', responseType: 'stream'}
}
